

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import icon16ChevronPurpleDown from './images/icon-16-chevron-purple-down.svg';


function Subscribers(props) {


  return (
    <div className='invoice-calls-subscribers'>
      <h2>פירוט שיחות למנויים</h2>
      <div className='subscriber-list'>
        {props.subscribers.map((subscriber, index) => {
          return <button key={index} className='subscriber-item'  onClick={() => {props.onClickSubscriber(subscriber)}}>
            <span>פירוט שיחות למנוי <span className='subscriber'>{subscriber.userPhone}</span></span>
            <div className='arrow-btn' style={{backgroundImage:icon16ChevronPurpleDown.bg()}}/>
          </button>
        })}
      </div>
    </div>

  );
}

const mapStateToProps = (state) => {
  return {

  };
};
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(Subscribers);
